export default __webpack_public_path__ + "static/media/pursuit-menu-calendar-off.71b258a7.svg";